import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'TabsHeader',

  mixins: [ proxy() ],

  props: {
    tabs: {
      type: Array,
      default: []
    }
  },

  render
}
